import { Controller } from "../Controller";
import { FormController } from "../Form/FormController";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Tag } from "../../HTML/Tag";
import { Form } from "../../HTML/Form/Form";
import { HtmlService } from "../../HTML/HtmlService";
import { Anchor } from "../../HTML/Anchor";
import { Div } from "../../HTML/Div";
import { toMap } from "../../../../HA";

export class PageController extends Controller {
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.createHtml();
        this.initForms();
        this.initControllers();
        this.createMenu();
    }

    protected createMenu() {
        const controllersData = toMap(this.get("controllers"));
        if (!controllersData || !controllersData.get("pm")) {
            return;
        }
        const pm = toMap(controllersData.get("pm") as any);
        if (pm.size > 0) {
            const tag: Tag = this.getTag();
            const t = tag.findByAttribute("tt=pa");
            if (t) {
                const div = new Tag({
                    c: [
                        {
                            attributes: [
                                {
                                    n: "id",
                                    v: "pagemenu",
                                },
                            ],
                            classes: ["xscroll", "ayyellow"],
                            t: "fc",
                        }],
                    class: "fixp",
                });
                t.addFistChild(div);
                const flexContainer = div.findById("pagemenu");
                if (flexContainer) {
                    pm.forEach((item: { n: any, a: string, html: any}) => {
                        const content = item.html ? [item.html] : item.n;
                        const d = new Div({
                            c: content,
                            class: "item",
                        });
                        const a = new Anchor(toMap({
                            attributes: [
                                {
                                    n: "d",
                                    v: item.a,
                                },
                                {
                                    n: "t",
                                    v: "reloadApp",
                                },
                            ],
                        }));
                        a.appendChild(d);
                        flexContainer.appendChild(a);
                    });
                }
            }
        }
    }

    protected createHtml() {
        if (this.get("pd")) {
            this.getTag().addClass("app_page");
            this.getTag().appendChild(HtmlService.createHtml(toMap(this.get("pd")), this.getServiceManager() as any));
        }
    }

    protected initForms() {
        const tag = this.getTag();
        const forms = tag.fetchByTagName("form");
        forms.forEach((form: Tag) => {
            if (form.getAttribute("i")) {
                return;
            }
            const data = new Map();
            data.set("tag", new Form(form));
            new FormController(data);
        });
    }
}

ControllerRegistry.register("PageController", PageController);
